import { render, staticRenderFns } from "./userLoginList.vue?vue&type=template&id=0b985c73&scoped=true"
import script from "./userLoginList.vue?vue&type=script&lang=js"
export * from "./userLoginList.vue?vue&type=script&lang=js"
import style0 from "./userLoginList.vue?vue&type=style&index=0&id=0b985c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b985c73",
  null
  
)

export default component.exports